import { useEffect } from 'react';

import { genesysBootstrap } from 'genesys/genesys-bootstrap';

import { useStartConversation } from 'hooks/useStartConversation';
import { useGenesysSubscribeEffect } from 'components/Docker/useGenesysSubscribeEffect';

let bootstraped = false;

export const useGenesysBootstrap = () => {
  useStartConversation();
  useGenesysSubscribeEffect();

  useEffect(() => {
    if (!bootstraped) {
      genesysBootstrap();

      bootstraped = true;
    }
  }, []);
};
